var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4421_9195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.514995 11.8563C0.514433 13.8728 1.0453 15.8417 2.05473 17.5771L0.418457 23.5066L6.5324 21.9156C8.22344 22.8292 10.1181 23.308 12.0435 23.3081H12.0486C18.4046 23.3081 23.5786 18.1748 23.5813 11.8653C23.5825 8.80792 22.3839 5.93295 20.2063 3.76997C18.029 1.60718 15.1334 0.415458 12.0481 0.414062C5.69131 0.414062 0.517713 5.54709 0.515089 11.8563",
    fill: "url(#paint0_linear_4421_9195)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.103217 11.8527C0.102561 13.9417 0.652452 15.981 1.69787 17.7786L0.00292969 23.9206L6.3361 22.2726C8.0811 23.2168 10.0458 23.7147 12.045 23.7154H12.0501C18.6342 23.7154 23.994 18.3975 23.9968 11.8621C23.998 8.69488 22.7563 5.71656 20.5008 3.47609C18.2451 1.23591 15.2459 0.00130233 12.0501 0C5.46492 0 0.105935 5.31721 0.10331 11.8527H0.103217ZM3.87476 17.469L3.63829 17.0965C2.64423 15.5277 2.11955 13.7149 2.1203 11.8534C2.12245 6.4213 6.5767 2.00186 12.0539 2.00186C14.7063 2.00298 17.1991 3.02921 19.074 4.89116C20.9488 6.7533 21.9804 9.22865 21.9798 11.8614C21.9773 17.2935 17.523 21.7135 12.0501 21.7135H12.0462C10.2642 21.7126 8.51645 21.2376 6.99228 20.34L6.62956 20.1265L2.87133 21.1045L3.87476 17.4689V17.469Z",
    fill: "url(#paint1_linear_4421_9195)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06402 6.90161C8.84039 6.40831 8.60504 6.39836 8.39238 6.38971C8.21824 6.38226 8.01916 6.38282 7.82027 6.38282C7.6212 6.38282 7.29775 6.45715 7.02435 6.75343C6.75067 7.04998 5.97949 7.76664 5.97949 9.22422C5.97949 10.6819 7.04919 12.0905 7.19831 12.2884C7.34761 12.4859 9.26338 15.5728 12.2975 16.7603C14.8191 17.7472 15.3322 17.5509 15.8795 17.5014C16.4269 17.4521 17.6457 16.785 17.8943 16.0931C18.1432 15.4014 18.1432 14.8085 18.0686 14.6846C17.994 14.5611 17.7949 14.487 17.4964 14.3389C17.1978 14.1907 15.7302 13.474 15.4566 13.3751C15.1829 13.2763 14.984 13.227 14.7849 13.5237C14.5858 13.8198 14.0142 14.487 13.8399 14.6846C13.6659 14.8826 13.4916 14.9073 13.1932 14.7591C12.8945 14.6104 11.9332 14.298 10.7926 13.2888C9.90521 12.5035 9.30612 11.5337 9.13197 11.2371C8.95783 10.9409 9.11332 10.7803 9.263 10.6327C9.39712 10.4999 9.56161 10.2867 9.71101 10.1138C9.85985 9.94078 9.90953 9.81733 10.0091 9.61975C10.1087 9.42198 10.0588 9.24896 9.98432 9.10078C9.90953 8.95259 9.32945 7.48747 9.06402 6.90171",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4421_9195",
    x1: 11.9999,
    y1: 23.5066,
    x2: 11.9999,
    y2: 0.414062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4421_9195",
    x1: 4.53398,
    y1: 22.5,
    x2: 21.0085,
    y2: 2.12853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835324,
    stopColor: "#57D162"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4421_9195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/WhatsappIcon.f16d5727ba36bda8fee2315fee72d17c.svg";
export { ForwardRef as ReactComponent };